import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "../images/logo.svg";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(""); // NEW
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!role) {
      setError("Please select a role");
      return;
    }

    try {
      const response = await fetch("https://senu-app.azurewebsites.net/api/admins/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, role }), // ✅ include role
      });

      if (response.ok) {
        const data = await response.json();
        console.log("Login successful:", data);
        localStorage.setItem(
  "adminData",
  JSON.stringify({
    fullName: data.admin.fullName,
    email: data.admin.email,
    role: data.admin.role,
    id: data.admin.id
  })
);
        
        // ✅ Redirect based on role
        if (data.role === "Station") {
          navigate("/station-dashboard");
        } else if (data.role === "Patrol") {
          navigate("/patrol-dashboard");
        } else {
          navigate("/loading");
        }
      } else {
        const errorData = await response.json();
        setError(errorData.message || "Login failed");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="login-container">
      <img src={logo} alt="Senu Logo" className="login-logo" />
      <h2 className="login-title">Security Admin</h2>

      <form className="login-form" onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          className="login-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Password"
          className="login-input"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        {/* Role Dropdown */}
        <select
          className="login-input"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          required
        >
          <option value="">Select Role</option>
          <option value="Station">Station</option>
          <option value="Patrol">Patrol</option>
        </select>

        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="login-button">Log In</button>
      </form>

      <p className="signup-text">
        Don’t have an account? <Link to="/admin-signup">Sign Up</Link>
      </p>
      <p className="forgot-text">
        <Link to="/forgot-password">Forgot Password?</Link>
      </p>
      <p className="admin-login-text">
        Are you a client? <Link to="/login">Client Login</Link>
      </p>
    </div>
  );
}
